module.exports = __webpack_public_path__ + "img/Bor-Borson-Jr_Falkberget-pa-kontoret.9c8672f0.jpg";